import * as ImageActions from '../actions/image.actions';

const initialState: {
    filename: string,
    image: any
} = {
    filename: null,
    image: null
}


export function imageReducer(state = initialState, action) {
  switch (action.type) {
    // case ImageActions.GET_IMAGE:
    //     return action.payload;
    case ImageActions.SET_IMAGE:
        return action.payload;
    default:
        return state;
    }
}